import React from "react";
import styles from "./BundleCard.module.scss";
import PricingFunctions from "common/PricingFunctions";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "actions/cart";
import { useSearchParams } from "react-router-dom";

const BundleCard = ({
    game,
    onAddToCartOverride,
    discountCode,
    discountPercentage,
    useOldPrice,
    buttonColor,
    noButton,
    showBanner,
    onClick,
    selected,
}) => {
    const dispatch = useDispatch();
    const pricing = useSelector((state) => state.pricing);
    const [searchParams, setSearchParams] = useSearchParams();

    // Use store-specific card image - no fallback, so missing data is visible
    const backgroundImage = game.meta?.storeCard;
    const accentImage = game.meta?.animatedAccent;
    const countryCode = pricing.countryCode;

    // Get current price
    const currentPrice = PricingFunctions.getGamePricing(countryCode, game, false)?.display;

    // Get old price if useOldPrice is true and old price raw value > 0
    const oldPricing = useOldPrice ? PricingFunctions.getGamePricing(countryCode, game, true) : null;
    const oldPrice = (oldPricing && oldPricing.raw > 0) ? oldPricing.display : null;

    // Fallback to discount calculation if not using old price
    const basePrice = PricingFunctions.getGamePricing(countryCode, game).raw;
    const currency = PricingFunctions.getCurrencySymbol(countryCode);
    const hasDiscount = !useOldPrice && !!discountPercentage && discountPercentage > 0;
    const discountedPrice = hasDiscount
        ? `${currency}${(basePrice * (1 - discountPercentage / 100)).toFixed(2)}`
        : currentPrice;

    //const handleAddToCart = () => {
    //    if (discountCode) {
    //        const updatedParams = new URLSearchParams(searchParams);
    //        updatedParams.set("discountCode", discountCode);
    //        setSearchParams(updatedParams);
    //    }
    //    if (onAddToCartOverride) {
    //        onAddToCartOverride(game);
    //    } else {
    //        dispatch(addToCart(game));
    //    }
    //};

    // Determine button style
    const buttonStyle = buttonColor ? { background: buttonColor } : {};

    return (
        <div className={`${styles.gameCardWrapper} ${noButton && styles.noButton} ${selected && styles.selected}`}>
            <div className={styles.gameCard} onClick={onClick}>
                <div className={styles.gameCardBackground}  style={{ backgroundImage: `url(${backgroundImage})` }} >
                    {accentImage && (
                        <img className={styles.cardCharacter} src={accentImage} alt="Accent" />
                    )}
                    {/*{*/}
                    {/*    showBanner &&*/}
                    {/*    <div className={styles.cornerBanner}>*/}
                    {/*            {useOldPrice ? currentPrice : discountedPrice}*/}
                    {/*    </div>*/}
                    {/*}*/}

                    <div className={styles.cornerAdded}>
                        <div className={`${styles.check} ${selected && styles.selected}`}><span>&#10004;</span></div>
                        {/*<div className={styles.texts}>*/}
                        {/*    <p className={`${selected && styles.show}`}>ADDED</p>*/}
                        {/*    <p className={`${!selected && styles.show}`} style={{ position: "absolute" }}>ADD</p>*/}
                        {/*</div>*/}
                    </div>
                </div>
                {
                    !noButton &&
                    <div className={styles.buttons} style={buttonStyle}>
                        <div className={styles.addToCart}>
                            Add To Cart
                            <span className={styles.discountPrice}>
                                {(useOldPrice && oldPrice) && (
                                    <span className={styles.originalPrice}>
                                        {oldPrice}
                                    </span>
                                )}
                                {(hasDiscount && !useOldPrice) && (
                                    <span className={styles.originalPrice}>
                                        {currency}{basePrice.toFixed(2)}
                                    </span>
                                )}
                                {useOldPrice ? currentPrice : discountedPrice}
                            </span>
                        </div>
                    </div>
                }

                {/*<div className={styles.bottomAdded}>*/}
                {/*    <p className={`${selected && styles.show}`}>ADDED</p>*/}
                {/*</div>*/}
            </div>

        </div>
    );
};

export default BundleCard;